import script from "./finalInspectionRecord.vue?vue&type=script&setup=true&lang=ts"
export * from "./finalInspectionRecord.vue?vue&type=script&setup=true&lang=ts"

import "./finalInspectionRecord.vue?vue&type=style&index=0&id=09ea1e0d&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09ea1e0d"]])

export default __exports__